
import { Container } from "inversify";
import { Component, Inject, Vue } from "vue-property-decorator";
import {
    FeedbackModalStore,
    FeedbackModalType,
} from "../../../../../common/src/feedback/FeedbackModalStore";

@Component
export default class BedrockOrgResearch extends Vue {
    @Inject("container") container!: Container;
    feedbackModalStore: FeedbackModalStore = this.container.get(FeedbackModalStore);

    get message() {
        return "Organization is currently in our research queue. Please contact us if you'd like to update this profile.";
    }

    get imagePath() {
        return "logo.svg";
    }

    get FeedbackModalType() {
        return FeedbackModalType;
    }
}
